import {NgModule} from '@angular/core'
import {NoPreloading, RouterModule, Routes} from '@angular/router'
import {NoAuthGuard} from "./guards/no-auth/no-auth.guard";
import {AuthGuard} from "./guards/auth/auth.guard";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'landing'
  },
  {
    path: 'landing',
    loadChildren: () => import('./views/landing/landing.module').then(m => m.LandingPageModule)
  },
  {
    path: 'language',
    loadChildren: () => import('./views/language/language.module').then((m) => m.LanguagePageModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./views/auth/login/login.module').then((m) => m.LoginPageModule),
    data: {hideHeader: true},
    canActivate: [NoAuthGuard]
  },
  {
    path: 'selection',
    loadChildren: () => import('./views/selection/selection.module').then((m) => m.SelectionPageModule),
    data: {hideHeader: true}
  },
  {
    path: 'register',
    loadChildren: () => import('./views/auth/register-form/register-form.module').then((m) => m.RegisterFormPageModule)
  },
  {
    path: 'recover',
    loadChildren: () => import('./views/auth/recover/recover.module').then((m) => m.RecoverPageModule)
  },
  {
    path: 'register-form',
    loadChildren: () => import('./views/auth/register-form/register-form.module').then((m) => m.RegisterFormPageModule)
  },
  {
    path: 'listing',
    loadChildren: () => import('./views/listing/listing.module').then((m) => m.ListingPageModule)
  },
  {
    path: 'featured',
    loadChildren: () => import('./views/featured/featured.module').then((m) => m.FeaturedPageModule)
  },
  {
    path: 'map',
    loadChildren: () => import('./views/map/map.module').then((m) => m.MapPageModule)
  },
  {
    path: 'details/:id',
    loadChildren: () => import('./views/details/details.module').then((m) => m.DetailsPageModule)
  },
  {
    path: 'details',
    loadChildren: () => import('./views/details/details.module').then((m) => m.DetailsPageModule),
    data: {mode: 'post'}
  },
  {
    path: 'report-content',
    loadChildren: () => import('./views/report/report.module').then((m) => m.ReportPageModule),
    data: {mode: 'contenido'}
  },
  {
    path: 'report-user',
    loadChildren: () => import('./views/report/report.module').then((m) => m.ReportPageModule),
    data: {mode: 'usuario'}
  },
  {
    path: 'create-post',
    loadChildren: () => import('./views/create-post/create-post.module').then((m) => m.CreatePostPageModule),
    data: {mode: 'create'},
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-post/:id',
    loadChildren: () => import('./views/edit-post/edit-post.module').then((m) => m.EditPostPageModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'messages/:id',
  //   loadChildren: () => import('./views/chat/messages/messages.module').then((m) => m.MessagesPageModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'edit-account',
    loadChildren: () => import('./views/my-account/edit-account/edit-account.module').then((m) => m.EditAccountPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-public-profile',
    loadChildren: () => import('./views/my-account/edit-public-profile/edit-public-profile.module').then((m) => m.EditPublicProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'my-posts',
    loadChildren: () => import('./views/my-account/my-posts/my-posts.module').then((m) => m.MyPostsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'my-posts/feature-days',
    loadChildren: () => import('./views/my-account/my-posts/feature-days/feature-days.module').then((m) => m.FeatureDaysPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'blocked-users',
    loadChildren: () => import('./views/my-account/blocked-users/blocked-users.module').then((m) => m.BlockedUsersPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'rewards',
    loadChildren: () => import('./views/my-account/rewards/rewards.module').then((m) => m.RewardsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contacts',
    loadChildren: () => import('./views/my-account/contacts/contacts.module').then((m) => m.ContactsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'user-profile/:id',
    loadChildren: () => import('./views/user-profile/user-profile.module').then(m => m.UserProfilePageModule),
    canActivate: [AuthGuard]
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: NoPreloading})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
